import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormBuilder } from '@angular/forms'

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'filter-form',
  templateUrl: './filter-form.component.html',
  styleUrls: ['./filter-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FilterFormComponent implements OnInit {
  filterModel = this.formBuilder.group({ filterText: [''] })

  @Output() filter: EventEmitter<string> = new EventEmitter<string>()

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {}

  get filterText(): string {
    return this.filterModel.value.filterText || ''
  }

  reset() {
    this.filterModel.reset({ filterText: '' })
    this.doFilter()
  }

  doFilter() {
    this.filter.emit(this.filterText)
  }

  get filterIsActive() {
    return this.filterText.length > 0
  }
}
